import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchEndorsements, addEndorsement, updateEndorsement, deleteEndorsement } from "./api";
import checkAuth from "./AuthCheck";

const AdminEndorsements = () => {
  const navigate = useNavigate();
  const isLoggedIn = checkAuth();

  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [endorsements, setEndorsements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [form, setForm] = useState({ title: "", image: null });

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    loadEndorsements();
  }, []);

  const loadEndorsements = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await fetchEndorsements();
      setEndorsements(Array.isArray(data) ? data : []);
    } catch (e) {
      setError("Failed to load endorsements");
    }
    setLoading(false);
  };

  const openAddModal = () => {
    setEditingId(null);
    setForm({ title: "", image: null });
    setError("");
    setShowModal(true);
  };

  const openEditModal = (item) => {
    setEditingId(item.id);
    setForm({ title: item.title || "", image: null });
    setError("");
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingId(null);
    setForm({ title: "", image: null });
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setForm({ ...form, image: files && files[0] ? files[0] : null });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!editingId && !form.image) {
      setError("Please choose an image to upload");
      return;
    }
    const formData = new FormData();
    formData.append("title", form.title.trim());
    if (form.image) formData.append("image", form.image);
    try {
      if (editingId) {
        await updateEndorsement(editingId, formData);
      } else {
        await addEndorsement(formData);
      }
      closeModal();
      setError("");
      loadEndorsements();
    } catch (e) {
      setError(editingId ? "Failed to update endorsement" : "Failed to add endorsement");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this endorsement?")) return;
    try {
      await deleteEndorsement(id);
      loadEndorsements();
    } catch (e) {
      setError("Failed to delete endorsement");
    }
  };

  return (
    <>
      <div className="horizontal gap-10 align-center" style={{ marginBottom: "20px" }}>
        <h1>Endorsements</h1>
        <button className="btn-primary-primary" onClick={openAddModal}>
          Add Endorsement
        </button>
      </div>

      {error && <div style={{ color: "red", marginBottom: 10 }}>{error}</div>}

      {loading ? (
        <div>Loading endorsements...</div>
      ) : endorsements.length === 0 ? (
        <div>No endorsements added yet.</div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 16 }}>
          {endorsements.map((item) => (
            <div key={item.id} className="event-card blog-cards" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {item.image && (
                <img src={item.image} alt={item.title || "Endorsement image"} style={{ width: "100%", height: 160, objectFit: "cover" }} />
              )}
              <div style={{ fontWeight: 600 }}>{item.title || "(No title)"}</div>
              <div style={{ display: "flex", gap: 8 }}>
                <button className="btn-primary-primary" onClick={() => openEditModal(item)}>Edit</button>
                <button className="btn-secondary" onClick={() => handleDelete(item.id)}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>{editingId ? "Edit Endorsement" : "Add Endorsement"}</h2>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="title"
                value={form.title}
                onChange={handleChange}
                placeholder="Optional title"
                className="input"
              />
              <input
                type="file"
                name="image"
                accept="image/*"
                onChange={handleChange}
                className="input"
                required={!editingId}
              />
              {editingId && (
                <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
                  Leave the image empty to keep the current one.
                </div>
              )}
              <div style={{ marginTop: "10px", display: "flex", justifyContent: "flex-end" }}>
                <button className="btn-primary-primary" type="submit">Save</button>
                <button className="btn-secondary" onClick={closeModal} style={{ marginLeft: "10px" }} type="button">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminEndorsements;
